



















import Vue from 'vue';
import { ISession, IABTest } from '@/store/types';
import { mapGetters } from 'vuex';
import { LOAD_STATE } from '@/store/shared';
import ABTestInfo from '@/components/Cancellation/ABTests/ABTestInfo.vue';
import ABTestRenameModal from '@/components/Cancellation/ABTests/ABTestRenameModal.vue';

export default Vue.extend({
  name: 'CancellationABTests',
  components: {
    ABTestInfo,
    ABTestRenameModal,
  },
  data() {
    return {
      LOAD_STATE,
      editABTest: {} as IABTest,
      showABTestRename: false as boolean,
      abTest: {
        name: '',
        winner: '',
        segmentId: '',
      } as {
        [key: string]: string | IABTest | undefined;
        name: string;
        winner: string;
        segmentId: string;
        selectedABTest: IABTest | undefined;
      },
    };
  },
  computed: {
    ...mapGetters(['lowData', 'orgCreatedDate', 'daysSinceOrgCreated', 'provider', 'abTests']),
    sessionsLoading(): boolean {
      return this.$store.state.recentSessionsLoadState !== LOAD_STATE.LOADED;
    },
    sessions(): ISession[] {
      return this.$store.state.recentSessions;
    },
    testSessions(): ISession[] {
      return this.$store.state.testSessions;
    },
  },
  methods: {
    handleABTest(abtest: IABTest) {
      this.editABTest = abtest;
      this.showABTestRename = true;
    },
    closeRenameABTestDialog() {
      this.showABTestRename = false;
    },
  },
});
